import React from 'react';
import { BookOpen } from 'lucide-react';
import { Card, Col, Row, Button, Container } from 'react-bootstrap';
import './InterviewCard.css'; // Keep your custom CSS file for animations


const INTERVIEW_QUESTIONS = [
  {
    id: "react-hooks",
    title: "Explain React Hooks",
    category: "https://cdn3d.iconscout.com/3d/free/thumb/react-5645899-4695757.png",
    difficulty: "Medium",
    estimatedTime: "5-10 min",
  },
  {
    id: "javascript-closure",
    title: "What is a JavaScript Closure?",
    category: "https://cdn3d.iconscout.com/3d/free/thumb/javascript-5645898-4695756.png",
    difficulty: "Hard",
    estimatedTime: "10-15 min",
  },
  {
    id: "css-grid",
    title: "CSS Grid vs Flexbox?",
    category: "https://cdn3d.iconscout.com/3d/free/thumb/css3-5645900-4695758.png",
    difficulty: "Easy",
    estimatedTime: "5 min",
  }
];



const InterviewCard = () => {
  // const navigate = useNavigate();
  // const hasShownToast = useRef(false);
  // const { hasPermission } = useAuth();
  // useEffect(() => {
  //   if (!hasPermission('student-id-card', 'view','lms')) {
  //     if (!hasShownToast.current) {
  //       toast.error('You do not have permission to add departments.');
  //       navigate('/');
  //       console.log("hello")
  //       hasShownToast.current = true;
  //     }
  //   }
  // }, [hasPermission, navigate]);
  return (
    <Container className="min-vh-100 py-4">
      <h1 className="text-center fw-bold mb-4 text-dark" style={{ fontSize: '2rem', textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}>
        Top Interview Questions
      </h1>
      
      <Row className="g-4">
        {INTERVIEW_QUESTIONS.map((question) => (
          <Col key={question.id} lg={4} md={6} sm={12}>
            <Card className="text-center border-0 rounded-3 shadow-lg overflow-hidden interview-question-card">
              <Card.Body className="p-4">
                
                {/* Title */}
                <Card.Title>{question.title}</Card.Title>

                {/* Image */}
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={question.category}
                    alt={`${question.title} Icon`}
                    className="rounded-circle border-3 border-warning shadow-sm interview-question-image"
                    style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                  />
                </div>

                {/* Difficulty & Time */}
                <div className="d-flex justify-content-center align-items-center my-3">
                      
                <Button className="d-flex align-items-center justify-content-center gap-2 py-2 px-3 rounded-3 shadow-sm interview-question-button">
                  <BookOpen className="me-2" />
                  Continue Learning
                </Button>
                </div>

                {/* Button */}
            

              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default InterviewCard;
